"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CheckIcon = function CheckIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.33314 12.9882L6.17814 10.8332C5.85276 10.5078 5.3252 10.5078 4.99981 10.8332C4.67442 11.1586 4.67442 11.6862 4.99981 12.0116L8.33314 15.3449L15.8331 7.84489C16.1585 7.5195 16.1585 6.99195 15.8331 6.66656C15.5078 6.34117 14.9802 6.34117 14.6548 6.66656L8.33314 12.9882Z",
    fill: color
  }));
};

var _default = CheckIcon;
exports.default = _default;